const getProductTypeFromQueryString = (query)=>{
    const params = new URLSearchParams(query);
    const productType = params.get('productType');
    return productType ? productType.toLowerCase() : undefined;
};

export { getProductTypeFromQueryString };
//# sourceMappingURL=get-product-type-from-query-string.js.map
